import type { FunctionComponent, PropsWithChildren } from 'react';
import MonarchSection from '~/cohesion/Monarch/MonarchSection';
import { everydaySansFont } from '~/styles/fonts/everydaySans';
import styles from './Layout.module.scss';
import { Skeleton } from '../shared/Skeleton';
import headerStyles from './Header/Header.module.scss';
import Footer from './Footer';
import SlimmedNavbar from '../editable/SlimmedNavbar';
import HoveringStickyMobileCTA from '../editable/HoveringStickyMobileCTA';
import { MonarchSlot, useMonarch } from '@redventures/cohesion-utils-react';

interface LayoutProps extends PropsWithChildren {
  signInButton?: boolean;
  url?: string;
  text?: string;
}

const Layout: FunctionComponent<LayoutProps> = ({
  children,
  signInButton = false,
  url,
  text,
}) => {
  const { isLoading } = useMonarch();

  return (
    <div className={everydaySansFont.className}>
      <header className={headerStyles.stickyWrapper}>
        <MonarchSection elementPosition='NAVBAR' componentName='Slimmed Navbar'>
          <MonarchSlot
            fallback={<Skeleton height='h-[50px]' />}
            slotId='navbar'
          >
            <SlimmedNavbar
              signInButton={signInButton}
              CTAButtonLink={url}
              CTAButtonText={text}
            />
          </MonarchSlot>
        </MonarchSection>
      </header>

      <main>{isLoading ? <Skeleton height='h-screen' /> : children}</main>

      {/* Footer */}
      <footer>
        <MonarchSection elementPosition='FOOTER' componentName='Footer'>
          <MonarchSlot
            fallback={<Skeleton height='h-[303px] lg:h-[219px]' />}
            slotId='footer'
          >
            <Footer />
          </MonarchSlot>
        </MonarchSection>
      </footer>

      {/* Bottom Sticky Section */}
      <aside className={`${styles.stickyWrapper} lg:hidden`}>
        <MonarchSection
          elementPosition='BOTTOM_STICKY_SECTION'
          componentName='Hovering Sticky Mobile CTA'
        >
          <MonarchSlot
            fallback={<Skeleton height='h-[80px]' />}
            slotId='bottomStickySection'
          >
            <HoveringStickyMobileCTA CTAButtonLink={url} CTAButtonText={text} />
          </MonarchSlot>
        </MonarchSection>
      </aside>
    </div>
  );
};

export default Layout;
